<!-- Guardando referência de como usar um menu -->

<!-- <mat-menu #menu="matMenu">
    <button mat-menu-item>Histórico</button>
    <button mat-menu-item>Consentimento</button>
</mat-menu> -->

<mat-toolbar [style.background-color]="configuration.headerBackgroundColor" [style.color]="configuration.headerTextColor">
  
  <mat-toolbar-row [class]="getTypographyClass()">
    <img [src]="configuration.headerAvatar | safe: 'resourceUrl'" class="serprobots-header-avatar">
    <div style="margin-left: 10px;" [style.font-size]="configuration.headerFontSize" [class]="getTypographyClass()">{{ configuration.headerTitle }} <span *ngIf="!configuration.isProductive"><small><b><i>[Em teste]</i></b></small></span></div>    
    <span class="toolbar-spacer"></span>

    <button *ngIf="!configuration.headerHideMinimizeButton" (click)="minimize()" mat-icon-button>
      <mat-icon>{{ configuration.headerMinimizeIcon }}</mat-icon>
    </button>

    <button *ngIf="!configuration.headerHideCloseButton" (click)="close()" mat-icon-button>
      <mat-icon>{{ configuration.headerCloseIcon }}</mat-icon>
    </button>
  </mat-toolbar-row>
  <!-- <span class="toolbar-spacer"></span>
  
    <button [matMenuTriggerFor]="menu" mat-icon-button>
    <mat-icon>more_horiz</mat-icon>
  </button> -->
</mat-toolbar>